import detai_mo from "../../assets/images/detai_mo.webp";
import detail_pc from "../../assets/images/detail_pc.webp";
import { Divider } from "@mui/material";
import resp from "../../assets/images/resp.webp";
import Swipi from "./Swipi";

export default function NewDetailBody() {
  return (
    <div className="w-full mt-10">
      <div className="container mx-auto p-3 flex flex-col gap-5 w-full lg:flex-row lg:gap-5">
        <div className="w-full flex flex-col gap-5 lg:w-9/12">
          <div className="w-full">
            <p>
              Chuyển đổi số trong giáo dục là một trong những lĩnh vực được ưu
              tiên hàng đầu trong tiến trình chuyển đổi số quốc gia. Ứng dụng
              các thành tựu công nghệ vào đào tạo và quản lý giáo dục giúp tối
              ưu bộ máy vận hành, nâng cao chất lượng đào tạo, hướng tới nguồn
              nhân lực chất lượng cao phục vụ đất nước. Bài chia sẻ những thông
              tin hữu ích về chuyển đổi số ngành giáo dục, thực trạng tại Việt
              Nam và những tham khảo các bước tiến hành chuyển đổi tại các cơ sở
              giáo dục. 
            </p>
          </div>
          <div className="w-full">
            <p>1. Chuyển đổi số trong giáo dục là gì? </p>
          </div>
          <div className="w-full">
            <p>
              Chuyển đổi số giáo dục là sự thay đổi về phương pháp giảng dạy,
              cải thiện thiết bị, dụng cụ hỗ trợ nhằm đáp ứng nhu cầu quản lý,
              giảng dạy, học tập, của học sinh, sinh viên, giảng viên và khuôn
              viên trường học. Là việc ứng dụng các thành tựu công nghệ vào quá
              trình giảng dạy, tạo môi trường kết nối mở, thu hẹp khoảng cách
              địa lý, nâng cao trải nghiệm học tập và tăng cường sự tương tác
              giữa các bên. 
            </p>
          </div>
          <div className="flex items-center justify-center">
            <img
              src={detai_mo}
              alt=""
              className="block md:hidden lg:hidden w-full h-auto"
            />
            <img
              src={detail_pc}
              alt=""
              className="hidden md:block lg:block w-full h-auto lg:w-[400px] lg:h-[300px]"
            />
          </div>
          <div>
            <p>
              Chuyển đổi số giáo dục là sự thay đổi về phương pháp giảng dạy,
              cải thiện thiết bị, dụng cụ hỗ trợ nhằm đáp ứng nhu cầu quản lý,
              giảng dạy, học tập, của học sinh, sinh viên, giảng viên và khuôn
              viên trường học. Là việc ứng dụng các thành tựu công nghệ vào quá
              trình giảng dạy, tạo môi trường kết nối mở, thu hẹp khoảng cách
              địa lý, nâng cao trải nghiệm học tập và tăng cường sự tương tác
              giữa các bên. 
            </p>
          </div>
          <div>
            <p>
              Chuyển đổi số ngành giáo dục thường được triển khai qua ba hình
              thức chính: (1) Ứng dụng công nghệ vào phương pháp giảng dạy, (2)
              Ứng dụng công nghệ vào quản lý giáo dục và (3) Ứng dụng công nghệ
              vào lớp học. Các hình thức trên sẽ phụ thuộc vào bộ máy cấu trúc
              và mục tiêu của từng cơ sở giáo dục cụ thể, điển hình như: Xây
              dựng, triển khai, đẩy mạnh nền tảng giáo dục trực tuyến Ứng dụng
              công nghệ vào các phương pháp giáo dục Số hóa thư viện, bài giảng,
              tư liệu giảng dạy Kết hợp song song hai hình thức giảng dạy trực
              tuyến và giảng dạy trực tiếp  Ứng dụng công nghệ vào hoạt động
              kiểm tra, theo dõi quá trình học tập của học sinh, sinh viên Tạo
              môi trường mở, có sự kết nối cho công tác học tập và giảng dạy
            </p>
          </div>
          <div>
            <p>2. Một số ví dụ về chuyển đổi số giáo dục</p>
          </div>
          <div>
            <p>
              Học tập trực tuyến (E-learning): Các nền tảng học trực tuyến:
              Coursera, Udemy, Khan Academy cung cấp các khóa học đa dạng từ
              nhiều lĩnh vực, cho phép học sinh và sinh viên học từ xa, mọi lúc,
              mọi nơi. Bài giảng video: YouTube và các nền tảng chia sẻ video
              khác cung cấp tài liệu học tập phong phú, bao gồm bài giảng, thí
              nghiệm và hướng dẫn. Lớp học ảo (Virtual Classroom): Zoom,
              Microsoft Teams, Google Meet: Các công cụ này cho phép giáo viên
              tổ chức lớp học trực tuyến, tương tác trực tiếp với học sinh qua
              video, chat và chia sẻ bài giảng qua màn hình. Hệ thống quản lý
              học tập (LMS): Moodle, Blackboard giúp quản lý khóa học, giao bài
              tập, chấm điểm và cung cấp tài liệu học tập. Hình thức học tập
              tương tác (Interactive Learning): Phần mềm mô phỏng và thực tế ảo
              (VR/AR): Sử dụng công nghệ VR và AR để tạo ra môi trường học tập
              sinh động, giúp học sinh hiểu sâu hơn về các khái niệm phức tạp.
              Ứng dụng di động: Duolingo, Photomath, Quizlet giúp học sinh học
              tập và ôn luyện qua các trò chơi và bài tập tương tác. Ứng dụng
              công nghệ Trí tuệ nhân tạo (AI) trong giáo dục: Hệ thống gợi ý học
              tập cá nhân hóa: AI phân tích dữ liệu học tập của học sinh để đưa
              ra gợi ý về lộ trình học tập phù hợp, giúp tối ưu hóa kết quả học
              tập. Chatbot hỗ trợ học tập: Chatbot có thể trả lời câu hỏi, cung
              cấp tài liệu học tập và hỗ trợ học sinh 24/7.
            </p>
          </div>
          <div>
            <p>3. Vai trò của chuyển đổi số giáo dục</p>
          </div>
          <div>
            <p>
              Chuyển đổi số trong giáo dục đem lại những lợi ích thiết thực cho
              việc giảng dạy, đào tạo và định hướng tư duy của học sinh, sinh
              viên.{" "}
            </p>
          </div>
          <div>
            <p>3.1. Nâng cao chất lượng giảng dạy</p>
          </div>
          <div>
            <p>
              Mô hình Giáo dục số sẽ giúp học sinh được tiếp cận nguồn học liệu
              phong phú, đa dạng thông qua các thiết bị điện tử như máy tính,
              máy tính bảng, điện thoại thông minh… Bên cạnh đó, việc ứng dụng
              công nghệ thông tin và chuyển đổi số trong giáo dục và đào tạo sẽ
              giúp tăng tính tương tác và trải nghiệm thực tế cho học viên.
              Những phần mềm “thực tế ảo” (AR, VR) đã và đang phát huy hiệu quả
              trong dạy học trực tuyến. Ví dụ, sinh viên y khoa có thể thực hành
              phẫu thuật trên các mô hình ảo, giúp họ làm quen với quy trình
              trước khi thực hành trên bệnh nhân thật.
            </p>
          </div>
          <div>
            <p>3.2. Nguồn thông tin đa dạng </p>
          </div>
          <div>
            <p>
              Sự bùng nổ của Internet và phát triển của công nghệ đem đến các
              nguồn thông tin, tài liệu dễ dàng được tìm thấy trên Internet với
              đa dạng chủ đề phục vụ nhu cầu học tập của học sinh và nâng cao
              chuyên môn của đội ngũ giáo viên hoàn toàn miễn phí. Tuy nhiên,
              cần có sự kiểm soát, chọn lọc một cách thông minh để có được nguồn
              tài liệu hữu ích, có độ chính xác, tin cậy cao.{" "}
            </p>
          </div>
          <div>
            <p>3.3. Tư duy mở, chủ động trong học tập</p>
          </div>
          <div>
            <p>
              Chuyển đổi số trong giáo dục tạo ra không gian học tập linh hoạt
              thông qua mạng Internet, đem đến khả năng học tập mọi lúc, mọi nơi
              thông qua các ứng dụng như: Zoom, Google Met,… người học chủ động
              tham gia các lớp học từ bất kỳ đâu. Các khóa học trực tuyến (ngoại
              ngữ, kỹ năng,…) đa dạng, người học chủ động tìm kiếm, lựa chọn lớp
              học phù hợp với mục đích và nhu cầu cá nhân
            </p>
          </div>
          <div>
            <p>3.4. Tiết kiệm thời gian, tối ưu chi phí</p>
          </div>
          <div>
            <p>
              Ứng dụng công nghệ vào giảng dạy giúp thầy cô, học sinh, phụ huynh
              có sự trao đổi thông tin nhanh chóng, quản lý lớp học dễ dàng,
              hiệu quả. Môi trường làm việc, giáo dục số giúp các cá nhân, tổ
              chức liên quan tiết kiệm thời gian, giảm thiểu chi phí nhân sự,
              tối ưu hóa chi phí đào tạo, vận hành.
            </p>
          </div>
          <div>
            <p>3. Bộ tiêu chí chuyển đổi số trong giáo dục</p>
          </div>
          <div>
            <p>
              {" "}
              Mục đích thiết lập Thúc đẩy chuyển đổi giáo dục tạo các số ở các
              cơ sở giáo dục ( trung tâm giáo dục thường xuyên, trường tiểu học,
              trường trung học cơ sở, trường trung học phổ thông). Theo dõi,
              đánh giá khách quan, thực chất, công bằng kết quả chuyển đổi số
              trong các cơ sở giáo dục. Phát hiện kịp thời các mô hình chuyển
              đổi số tốt, có hiệu quả, tính ứng dụng cao để nhân rộng, tạo phong
              trào thực hiện chuyển đổi số trong toàn ngành Giáo dục. Đối tượng
              và phạm vi áp dụng Phạm vi: Tất cả các tỉnh thành thuộc lãnh thổ
              Việt Nam Đối tượng: Các sở giáo dục và đào tạo, các phòng giáo dục
              và đào tạo, các cơ sở giáo dục phổ thông và trung tâm giáo dục
              thường xuyên. Mức độ chuyển đổi số Các mức độ chuyển đổi số ngành
              giáo dục được đáng giá theo từng nhóm tiêu chí thành phần (tối đa
              100 điểm), mỗi nhóm tiêu chí được đánh giá theo ba mức độ: Mức độ
              1 – chưa đáp ứng: Cơ sở giáo dục chưa đáp ứng được những yêu cầu
              cơ bản về triển khai chuyển đổi số ( tổng điểm mỗi nhóm tiêu chí
              dưới 50 điểm). Mức độ 2 – đáp ứng cơ bản: Cơ sở giáo dục đáp ứng
              được các yêu cầu cơ bản về triển khai chuyển đổi số (tổng điểm mỗi
              nhóm tiêu chí từ 50 đến 75 điểm). Mức độ 3 – đáp ứng tốt: Cơ sở
              giáo dục đáp ứng tốt các yêu cầu cơ bản và một phần các yêu cầu
              nâng cao về triển khai chuyển đổi số (tổng điểm mỗi nhóm tiêu chí
              đạt từ 75 điểm).
            </p>
          </div>
        </div>
        <div className="block md:hidden lg:hidden">
          <Divider />
        </div>

        <div className="w-full grid grid-cols-1 gap-4 lg:w-3/12 lg:h-[500px]">
          <div>
            <p className="text-[28px] text-[#033F6A] font-semibold">
              Tin liên quan
            </p>
          </div>
          <div className="w-full h-[149px] rounded-[6px] bg-white border border-solid border-gray-200 flex items-center gap-4 ">
            <div>
              <img
                src={resp}
                alt=""
                className="rounded-s-md h-[149px] w-full"
              />
            </div>
            <div className="flex flex-col gap-2">
              <div>
                <p className="text-[14px] text-[#919191] font-normal">
                  Tin tức
                </p>
              </div>
              <div>
                <p className="text-[14px] text-[#1F1F1F] font-semibold w-[198px]">
                  Lorem ipsum dolor sit amet onsecte
                </p>
              </div>
              <div>
                <p className="text-[14px] text-[##33333] font-normal w-[198px]">
                  In ac congue elit. Pellentesque quis feugiat
                </p>
              </div>
            </div>
          </div>
          <div className="w-full h-[149px] rounded-[6px] bg-white border border-solid border-gray-200 flex items-center gap-4 ">
            <div>
              <img
                src={resp}
                alt=""
                className="rounded-s-md h-[149px] w-full"
              />
            </div>
            <div className="flex flex-col gap-2">
              <div>
                <p className="text-[14px] text-[#919191] font-normal">
                  Tin tức
                </p>
              </div>
              <div>
                <p className="text-[14px] text-[#1F1F1F] font-semibold w-[198px]">
                  Lorem ipsum dolor sit amet onsecte
                </p>
              </div>
              <div>
                <p className="text-[14px] text-[##33333] font-normal w-[198px]">
                  In ac congue elit. Pellentesque quis feugiat
                </p>
              </div>
            </div>
          </div>
          <div className="w-full h-[149px] rounded-[6px] bg-white border border-solid border-gray-200 flex items-center gap-4 ">
            <div>
              <img
                src={resp}
                alt=""
                className="rounded-s-md h-[149px] w-full"
              />
            </div>
            <div className="flex flex-col gap-2">
              <div>
                <p className="text-[14px] text-[#919191] font-normal">
                  Tin tức
                </p>
              </div>
              <div>
                <p className="text-[14px] text-[#1F1F1F] font-semibold w-[198px]">
                  Lorem ipsum dolor sit amet onsecte
                </p>
              </div>
              <div>
                <p className="text-[14px] text-[##33333] font-normal w-[198px]">
                  In ac congue elit. Pellentesque quis feugiat
                </p>
              </div>
            </div>
          </div>
          <div className="w-full h-[149px] rounded-[6px] bg-white border border-solid border-gray-200 flex items-center gap-4 ">
            <div>
              <img
                src={resp}
                alt=""
                className="rounded-s-md h-[149px] w-full"
              />
            </div>
            <div className="flex flex-col gap-2">
              <div>
                <p className="text-[14px] text-[#919191] font-normal">
                  Tin tức
                </p>
              </div>
              <div>
                <p className="text-[14px] text-[#1F1F1F] font-semibold w-[198px]">
                  Lorem ipsum dolor sit amet onsecte
                </p>
              </div>
              <div>
                <p className="text-[14px] text-[##33333] font-normal w-[198px]">
                  In ac congue elit. Pellentesque quis feugiat
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container mx-auto p-3">
        <div>
          <p className="text-[28px] text-[#033F6A] font-semibold">
            Bạn có thể quan tâm
          </p>
        </div>
        <div className="bg-[#F8FFFF]">
          <Swipi />
        </div>
      </div>
    </div>
  );
}
